import * as React from 'react';
import { Calendar, Clock } from 'lucide-react';
import { format } from 'date-fns';

interface InterviewCardScheduleProps {
    scheduledDate: Date;
}

const InterviewCardSchedule: React.FC<InterviewCardScheduleProps> = ({ scheduledDate }) => {
    return (
        <div className="flex flex-col gap-2 text-sm text-gray-600 sm:flex-row sm:items-center dark:text-gray-100">
            <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4 text-[#26BDB0]" />
                <strong>{format(scheduledDate, 'PPP')}</strong>
            </div>
            <div className="flex items-center gap-1">
                <Clock className="w-4 h-4 text-[#26BDB0]" />
                <strong>{format(scheduledDate, 'p')}</strong>
            </div>
        </div>
    );
};

export default InterviewCardSchedule;
